<template>
  <el-dialog
    :title="type == 'add' ? '新增随车人员信息' : '编辑随车人员信息'"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="60%"
  >
    <div class="dlialog-box">
      <div class="photo_box">
        <el-tooltip class="item" effect="dark" content="头像" placement="top">
          <head-portrait-up-load
            :imageUrl="ruleForm.entouragePhoto"
            @imageChange="imageChange"
          ></head-portrait-up-load>
        </el-tooltip>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        style="width:100%"
        class="demo-ruleForm"
      >
        <div class="form_row_box">
          <el-form-item label="姓名:" prop="entouragName">
            <el-input
              v-model.trim="ruleForm.entouragName"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model="ruleForm.entouragGender"
              placeholder="请选择性别"
              size="small"
              clearable
              style="width:90%"
            >
              <el-option
                v-for="(item, index) in personnelSex"
                :key="index"
                :label="item.nameOne"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form_row_box">
          <el-form-item label="出生日期:">
            <el-date-picker
              v-model="ruleForm.entouragDateBirth"
              type="date"
              value-format="timestamp"
              size="small"
              style="width:90%"
              clearable
              :picker-options="pickerDateOptionsOne"
              placeholder="选择出生日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工作单位:">
            <el-input
              v-model.trim="ruleForm.entouragEmployer"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
        </div>

        <div class="form_row_box">
          <el-form-item label="证件类型:">
            <el-select
              v-model="ruleForm.entouragTypeCertificate"
              placeholder="请选择证件类型"
              size="small"
              clearable
              style="width:90%"
            >
              <el-option
                v-for="(item, index) in certificateType"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码:">
            <el-input
              v-model.trim="ruleForm.entouragIdNumber"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form_row_box">
          <el-form-item label="单位性质:">
            <el-input
              v-model.trim="ruleForm.entouragUnitNature"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="人员性质:">
            <el-input
              v-model.trim="ruleForm.entouragPersonnelNature"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form_row_box">
          <el-form-item label="固定电话:">
            <el-input
              v-model.trim="ruleForm.entouragFixedNumber"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码:">
            <el-input
              v-model.trim="ruleForm.entouragCellphoneNumber"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form_row_box">
          <el-form-item label="家庭住址:">
            <el-input
              v-model.trim="ruleForm.entouragHomeAddress"
              size="small"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="save-box">
      <div class="cut_off_rule"></div>
      <div class="button_box">
        <el-button
          type="primary"
          size="small"
          plain
          @click="saveClick('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" plain @click="close">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HeadPortraitUpLoad
  },
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: () => {
        return "add";
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    //这里存放数据
    return {
      pickerDateOptionsOne: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      ruleForm: {},
      rules: {
        entouragName: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      if (val) {
        this.ruleForm = this.info;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {
    personnelSex() {
      return this.$store.state.select.personnelSex;
    },
    certificateType() {
      return this.$store.state.select.certificateTypeTwo;
    }
  },
  //方法集合
  methods: {
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveClick", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
    },
    imageChange(src) {
      this.ruleForm.entouragePhoto = src || "";
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.dlialog-box {
  height: 560px;
  width: 100%;
  overflow-y: scroll;
}
.photo_box {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.save-box {
  height: 50px;
  width: 100%;
}
.cut_off_rule {
  width: 100%;
  height: 1px;
  margin: 2px;
  background-color: gray;
}
.button_box {
  float: right;
  margin-right: 20px;
  height: 45px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.form_row_box {
  width: 100%;
  display: flex;
  div {
    width: 50%;
  }
}
</style>
